import DataTable from "react-data-table-component";
import React, { useState, useMemo } from "react";

const Table = ({ columns, data, waterMark }) => {
  const [paginationPage, setPaginationPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const hasSNoColumn = columns.some((col) => col.name === "S.No");

  const NoDataIndication = () => (
    <div className="empty-container">
      <div className="empty-state">
        <div className="empty-icon">📊</div>
        <h3>No Data Available</h3>
        <p>Adjust your filters or check back later for trading results</p>
      </div>
    </div>
  );

  const customColumns = useMemo(() => {
    if (hasSNoColumn) return [...columns];
    return [
      {
        name: "No",
        selector: (row, index) =>
          (paginationPage - 1) * rowsPerPage + index + 1,
        sortable: false,
        width: "70px",
      },
      ...columns.map((col) => ({
        ...col,
     
      })),
    ];
  }, [columns, hasSNoColumn, paginationPage, rowsPerPage]);


  const handlePageChange = (page) => {
    setPaginationPage(page);
  };

  const handleRowsPerPageChange = (newPerPage, page) => {
    setRowsPerPage(newPerPage);
    setPaginationPage(1); // reset to first page
  };

  const watermarkOverlayStyle = {
    position: "absolute",
    inset: 0,
    backgroundImage: `url(${localStorage.getItem("watermark")})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "contain",
    opacity: 0.4,
    pointerEvents: "none",
    zIndex: 0,
  };

  return (
    <div className="table-responsive" style={{ position: "relative" }}>
      {waterMark && <div style={watermarkOverlayStyle} />}
      <div style={{ position: "relative", zIndex: 1 }}>
        <DataTable
          columns={customColumns}
          data={data}
          pagination
          paginationPerPage={rowsPerPage}
          paginationPage={paginationPage}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          paginationRowsPerPageOptions={[1, 2, 10, 20, 50, 100]}
          // highlightOnHover
          striped
          customStyles={customStyles}
          responsive={true}
          paginationComponentOptions={{
            rowsPerPageText: "Rows per page:",
            noRowsPerPage: false,
          }}
          noDataComponent={<NoDataIndication />}
        />
      </div>
    </div>
  );
};

const customStyles = {
  header: {
    style: {
      minHeight: "50px",
      backgroundColor: "#4CAF50",
      color: "#fff",
      fontSize: "14px", // ↓ reduced from 16px
      fontWeight: "600",
      borderRadius: "10px 10px 0 0",
      textAlign: "center",
    },
  },
  headRow: {
    style: {
      borderBottomWidth: "2px",
      borderBottomColor: "#ddd",
      borderBottomStyle: "solid",
      backgroundColor: "#f1f1f1",
    },
  },
  headCells: {
    style: {
      fontWeight: "bold",
      fontSize: "13px", // ↓ reduced from 15px
      color: "#333",
      padding: "8px 16px", // ↓ slightly smaller padding
      textAlign: "center",
      whiteSpace: "nowrap",
    },
  },
  cells: {
    style: {
      padding: "10px 16px", // ↓ reduced a bit
      fontSize: "10px", // ↓ reduced from 14px
      color: "#555",
      fontWeight: "500",
      backgroundColor: "#fff",
      borderBottom: "1px solid #eee",
      textAlign: "center",
      transition: "background-color 0.3s",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    activeStyle: {
      backgroundColor: "#e7f7e7",
    },
  },
  rows: {
    highlightOnHoverStyle: {
      backgroundColor: "#f0f8ff",
      cursor: "pointer",
    },
    stripedStyle: {
      backgroundColor: "#fafafa", // lighter stripe
    },
  },
};


export default Table;
